import React from "react";
import "./loader.css";
const Loader = () => {
  return (
    <div className="loaderMain">
      <div className="loader"></div>
    </div>
  );
};

export default Loader;
